// Module permission keys used across navigation + in-page feature flags.
// User.permissions empty array => falls back to ROLE_DEFAULTS.
export const MODULES = [
  { key: 'dashboard', label: 'Dashboard' },
  { key: 'patients', label: 'Patients' },
  { key: 'appointments', label: 'Appointments & Queue' },
  { key: 'optometry', label: 'Optometry Workup' },
  { key: 'doctor', label: 'Doctor Consultation' },
  { key: 'opd', label: 'OPD / Dispensing' },
  { key: 'billing', label: 'Billing & Payments' },
  { key: 'followups', label: 'Follow-up Recall' },
  { key: 'medicines', label: 'Medicines' },
  { key: 'analytics', label: 'Analytics' },
  { key: 'reports', label: 'Reports' },
  { key: 'timer', label: 'Stage Timer / Timeline' },
  { key: 'patient_history', label: 'Patient History' },
  { key: 'printing', label: 'Print Rx / Invoice / Receipt' },
];

export const ROLE_DEFAULTS = {
  reception: ['dashboard', 'patients', 'appointments', 'billing', 'followups', 'timer', 'patient_history', 'printing'],
  optometrist: ['dashboard', 'patients', 'optometry', 'timer', 'patient_history'],
  doctor: ['dashboard', 'patients', 'doctor', 'followups', 'medicines', 'analytics', 'reports', 'timer', 'patient_history', 'printing'],
  opd: ['dashboard', 'patients', 'opd', 'billing', 'timer', 'patient_history', 'printing'],
  admin: MODULES.map((m) => m.key),
};

export const effectivePermissions = (user) => {
  if (!user) return [];
  if (user.role === 'admin') return MODULES.map((m) => m.key);
  if (user.permissions && user.permissions.length > 0) return user.permissions;
  return ROLE_DEFAULTS[user.role] || [];
};

export const hasPermission = (user, key) => {
  if (!key) return true;
  if (!user) return false;
  return effectivePermissions(user).includes(key);
};
